<template>
    <VJoyButton
        variant="secondary"
        size="xsmall"
        :label="$t('profile.vetting.drawer.cancel')"
        data-testid="vetting-edition-cancel-button"
        @click="profileQualificationStore.leaveEditMode()"
    />
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';

    const profileQualificationStore = useProfileQualificationStore();
</script>
